/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refer_Sellers_And_Earn_CommissInputs */

const en_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refer sellers and earn commissions on their subscription fees.`)
};

const es_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refiere vendedores y gana comisiones de sus tarifas de suscripción.`)
};

const fr_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parrainez des vendeurs et gagnez des commissions sur leurs frais d'abonnement.`)
};

const de_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermittle Verkäufer und verdiene Provisionen auf deren Abonnementgebühren.`)
};

const ja_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品者を紹介し、そのサブスクリプション料金から紹介料を獲得しましょう。`)
};

const zh_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐卖家并在他们支付订阅费时赚取佣金。`)
};

const ar_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قُم بإحالة البائعين واكسب عمولات على رسوم اشتراكاتهم.`)
};

const id_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rujuk penjual dan dapatkan komisi dari biaya langganan mereka.`)
};

const it_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita i venditori e guadagna commissioni sulle loro quote di abbonamento.`)
};

const ru_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привлекайте продавцов и получайте комиссионные с их абонентской платы.`)
};

const pt_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique vendedores e ganhe comissões sobre suas taxas de assinatura.`)
};

const ko_refer_sellers_and_earn_commiss = /** @type {(inputs: Refer_Sellers_And_Earn_CommissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자를 추천하고 구독료에 대한 수수료를 받으세요.`)
};

/**
* | output |
* | --- |
* | "Refer sellers and earn commissions on their subscription fees." |
*
* @param {Refer_Sellers_And_Earn_CommissInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const refer_sellers_and_earn_commiss = /** @type {((inputs?: Refer_Sellers_And_Earn_CommissInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refer_Sellers_And_Earn_CommissInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refer_sellers_and_earn_commiss(inputs)
	if (locale === "es") return es_refer_sellers_and_earn_commiss(inputs)
	if (locale === "fr") return fr_refer_sellers_and_earn_commiss(inputs)
	if (locale === "de") return de_refer_sellers_and_earn_commiss(inputs)
	if (locale === "ja") return ja_refer_sellers_and_earn_commiss(inputs)
	if (locale === "zh") return zh_refer_sellers_and_earn_commiss(inputs)
	if (locale === "ar") return ar_refer_sellers_and_earn_commiss(inputs)
	if (locale === "id") return id_refer_sellers_and_earn_commiss(inputs)
	if (locale === "it") return it_refer_sellers_and_earn_commiss(inputs)
	if (locale === "ru") return ru_refer_sellers_and_earn_commiss(inputs)
	if (locale === "pt") return pt_refer_sellers_and_earn_commiss(inputs)
	return ko_refer_sellers_and_earn_commiss(inputs)
});